(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    root.CBMCartUx = api;
    if (api.boot && root.document) api.boot(root.document, root);
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  var booted = false;
  var providerUpdateQueued = false;

  // Only presentation is immediate; writes still use the existing 300ms debounce and queue.
  function quantityChangeHandler(controller) {
    var container = controller.container;
    var entries = [];
    var delayed = null;
    var timer;
    function itemKey(input) {
      return input.closest('quantity-selector')?.dataset.id || input.closest('[data-product-id]')?.dataset.productId;
    }
    function render() {
      container.querySelectorAll('input.qty').forEach(function (input) {
        var selector = input.closest('quantity-selector');
        if (!selector) return;
        var busy = entries.some(function (entry) { return entry.key === itemKey(input); });
        var label = selector.querySelector('[data-cbm-quantity-status]');
        if (busy && !label) {
          selector.classList.add('cbm-quantity-pending');
          input.setAttribute('aria-busy', 'true');
          label = container.ownerDocument.createElement('span');
          label.className = 'cbm-quantity-status';
          label.setAttribute('data-cbm-quantity-status', '');
          label.setAttribute('role', 'status');
          label.textContent = window.theme.strings.cartUpdating;
          selector.appendChild(label);
        } else if (!busy && label) {
          label.remove();
          selector.classList.remove('cbm-quantity-pending');
          input.removeAttribute('aria-busy');
        }
      });
    }
    function finish(entry) {
      entries = entries.filter(function (current) { return current !== entry; });
      render();
    }
    controller.cbmQuantityFeedback = { render: render };
    return function (event) {
      clearTimeout(timer);
      if (delayed) finish(delayed);
      delayed = null;
      var input = event.target;
      if (!input.matches('input.qty')) {
        timer = setTimeout(function () { controller.onChange(event); }, 300);
        return;
      }
      var key = itemKey(input);
      var quantity = Number(input.value);
      if (!key || !input.checkValidity() || !Number.isInteger(quantity) || quantity < 1) return;
      var entry = { key: key, quantity: quantity };
      delayed = entry;
      entries.push(entry);
      render();
      timer = setTimeout(function () {
        delayed = null;
        var current = container.isConnected && Array.from(container.querySelectorAll('input.qty')).find(function (field) { return itemKey(field) === entry.key; });
        if (!current) { finish(entry); return; }
        Promise.resolve().then(function () {
          return controller.updateQuantity(current.dataset.index, entry.quantity);
        }).finally(function () { finish(entry); }).catch(function () {
          controller.setNeedsSync(true);
          if (controller.showRecoveryError) controller.showRecoveryError();
        });
      }, 300);
    };
  }

  function protectionCheckoutGuard(document, win) {
    var pending = null;
    // Seel detects merchandise by variant and quantity, not discount-dependent line keys or totals.
    function signature(cart, paidOnly) {
      var quantities = {};
      (cart && cart.items || []).forEach(function (item) {
        if (item.handle === 'worry-free-purchase' || (paidOnly && item.final_line_price === 0)) return;
        var id = item.variant_id || item.key;
        quantities[id] = (quantities[id] || 0) + item.quantity;
      });
      return JSON.stringify(Object.keys(quantities).sort().map(function (id) { return [id, quantities[id]]; }));
    }
    function matches(p) {
      // Automatic free gifts may change after the quantity response; paid quantities must still match.
      return p.expected && (p.expected === p.observed || (p.expectedPaid && p.expectedPaid === p.observedPaid));
    }
    function provider() { return document.querySelector('.seal-widget [data-seel-wfp-input]'); }
    function render() {
      var busy = pending || document.cbmDiscountPending || document.querySelector('[data-cbm-quantity-status]');
      ['Cart', 'Cart-Drawer'].forEach(function (id) {
        var host = document.getElementById(id);
        if (!host) return;
        var button = host.querySelector('.button.checkout, .button.checkout-button');
        if (!button) return;
        if (busy && !button.disabled) {
          button.setAttribute('data-cbm-protection-locked', '');
          button.disabled = true;
        } else if (!busy && button.hasAttribute('data-cbm-protection-locked')) {
          button.removeAttribute('data-cbm-protection-locked');
          button.disabled = false;
        }
        var express = host.querySelector('.additional-checkout-buttons');
        if (express && busy && !express.inert) {
          express.setAttribute('data-cbm-protection-locked', '');
          express.inert = true;
        } else if (express && !busy && express.hasAttribute('data-cbm-protection-locked')) {
          express.removeAttribute('data-cbm-protection-locked');
          express.inert = false;
        }
        var notice = host.querySelector('[data-cbm-protection-status]');
        if (!pending) { if (notice) notice.remove(); return; }
        if (!notice) {
          notice = document.createElement('p');
          notice.className = 'cbm-cart-discount-feedback';
          notice.setAttribute('data-cbm-protection-status', '');
          notice.setAttribute('role', 'status');
          var anchor = host.querySelector('.cart-drawer-buttons, .proceed-to-checkout') || button;
          anchor.parentNode.insertBefore(notice, anchor);
        }
        var message = pending.failed ? win.theme.strings.protectionSyncError : win.theme.strings.protectionUpdating;
        if (notice.firstChild && notice.firstChild.textContent === message) return;
        notice.replaceChildren(document.createTextNode(message));
        if (pending.failed) {
          var link = document.createElement('a');
          link.href = win.theme.routes.cart_url;
          link.textContent = win.theme.strings.viewCart;
          notice.append(' ', link);
        }
      });
    }
    function clear() {
      if (pending) win.clearTimeout(pending.timer);
      pending = null;
      render();
    }
    function check() {
      render();
      var p = pending, input = provider();
      if (!p || p.reading) return;
      if (input && input.disabled) { if (p.observed) p.sawBusy = true; return; }
      if (!matches(p) || !p.sawBusy || !input || document.querySelector('.seal-widget .loading-animation')) return;
      var host = document.getElementById('Cart') || document.getElementById('Cart-Drawer');
      var controller = host && (host.cbmCartController || host.cbmCartDrawerController);
      if (!controller) return;
      p.reading = true;
      // Reuse the provider-triggered refresh when present; otherwise read once for an unchanged fee.
      var refresh = p.refresh || controller.refresh();
      Promise.resolve(refresh).then(function (result) {
        if (pending !== p) return;
        if (!result || controller.needsSync) throw new Error('protection-sync-failed');
        clear();
      }).catch(function () {
        if (pending !== p) return;
        win.clearTimeout(p.timer);
        p.failed = true;
        render();
      });
    }
    function start() {
      var input = provider();
      if (!input || !input.checked) return;
      clear();
      var p = pending = {};
      p.timer = win.setTimeout(function () {
        if (pending !== p) return;
        p.failed = true;
        render();
      }, 10000);
      render();
    }
    function confirm(cart, unchanged) {
      if (!pending) return;
      if (!cart || !cart.items || !cart.items.some(function (item) { return item.handle !== 'worry-free-purchase'; })) { clear(); return; }
      pending.expected = signature(cart);
      pending.expectedPaid = signature(cart, true);
      var input = provider();
      if (unchanged && !pending.observed && input && !input.disabled) { clear(); return; }
      check();
    }
    document.addEventListener('line-item:change:start', function () {
      var fields = Array.from(document.querySelectorAll('quantity-selector.cbm-quantity-pending input.qty'));
      if (!pending && fields.length && fields.every(function (field) { return field.value === field.defaultValue; })) return;
      start();
    });
    document.addEventListener('line-item:change:end', function (event) { confirm(event.detail && event.detail.cart); });
    document.addEventListener('line-item:change:error', clear);
    document.addEventListener('seel_event_center', function (event) {
      if (!event.detail || event.detail.type !== 'CART_CHANGE_OF_INTEREST_OBSERVED') return;
      if (!pending) {
        start();
        if (pending) {
          pending.expected = signature(event.detail.payload && event.detail.payload.cart);
          pending.expectedPaid = signature(event.detail.payload && event.detail.payload.cart, true);
        }
      }
      if (!pending) return;
      pending.observed = signature(event.detail.payload && event.detail.payload.cart);
      pending.observedPaid = signature(event.detail.payload && event.detail.payload.cart, true);
      pending.sawBusy = false;
      check();
    });
    document.addEventListener('cart:refresh', function () {
      var p = pending;
      if (!p || !matches(p) || !p.sawBusy) return;
      var host = document.getElementById('Cart') || document.getElementById('Cart-Drawer');
      var controller = host && (host.cbmCartController || host.cbmCartDrawerController);
      var previous = controller && controller.cbmCartMutationQueue;
      win.queueMicrotask(function () {
        if (pending === p && controller && controller.cbmCartMutationQueue !== previous) p.refresh = controller.cbmCartMutationQueue;
      });
    });
    function preventCheckout(event) {
      var target = event.target;
      var checkout = target && target.closest && (event.type === 'submit'
        ? target.querySelector('[name="checkout"], .checkout-button')
        : target.closest('[name="checkout"], .checkout-button'));
      if (!checkout || !checkout.closest('#Cart, #Cart-Drawer')) return;
      if (pending || document.cbmDiscountPending || document.querySelector('[data-cbm-quantity-status]')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        render();
      }
    }
    document.addEventListener('click', preventCheckout, true);
    document.addEventListener('submit', preventCheckout, true);
    return { check: check, render: render, start: start, confirm: confirm, fail: function () { if (pending) { pending.failed = true; render(); } } };
  }

  function normalizeCodes(codes) {
    return (Array.isArray(codes) ? codes : [])
      .map(function (code) {
        return String(code || '').trim().replace(/,/g, '');
      })
      .filter(Boolean);
  }

  function buildDiscountPayload(codes, pathname, hasPageCart) {
    return {
      discount: normalizeCodes(codes).join(','),
      sections: hasPageCart ? 'main-cart,cart-drawer,cart-bubble' : 'cart-drawer,cart-bubble',
      sections_url: pathname && pathname.charAt(0) === '/' ? pathname : '/cart'
    };
  }

  function discountCodesForSubmission(existingCodes, submittedCode) {
    return normalizeCodes([submittedCode]);
  }

  function nextScrollLeft(track, direction) {
    var maximum = Math.max(0, Number(track.scrollWidth) - Number(track.clientWidth));
    var step = Math.max(1, Math.round(Number(track.clientWidth) * 0.9));
    return Math.min(maximum, Math.max(0, Number(track.scrollLeft) + (direction < 0 ? -step : step)));
  }

  function hasRenderedCode(html, code, Parser) {
    var wanted = String(code || '').trim().toLowerCase();
    if (!wanted) return false;

    if (typeof Parser === 'function') {
      var parsed = new Parser().parseFromString(String(html || ''), 'text/html');
      return Array.prototype.some.call(parsed.querySelectorAll('[data-cbm-discount-code]'), function (chip) {
        return String(chip.getAttribute('data-cbm-discount-code') || '').trim().toLowerCase() === wanted;
      });
    }

    var source = String(html || '');
    var attribute = /data-cbm-discount-code\s*=\s*(["'])(.*?)\1/gi;
    var match;
    while ((match = attribute.exec(source))) {
      if (String(match[2]).trim().toLowerCase() === wanted) return true;
    }
    return false;
  }

  function replaceSections(document, sections, Parser) {
    if (!document || !sections || typeof Parser !== 'function') return false;
    var definitions = [
      { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form', required: true },
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer', required: true },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count', required: true }
    ];
    var updates = [];
    for (var index = 0; index < definitions.length; index += 1) {
      var definition = definitions[index];
      var host = document.getElementById(definition.id);
      if (!host) continue;
      var html = sections[definition.section];
      var parsed = typeof html === 'string'
        ? new Parser().parseFromString(html, 'text/html').querySelector(definition.selector)
        : null;
      if (!host || !parsed) {
        if (definition.required) return false;
        continue;
      }
      updates.push({ host: host, target: host.querySelector(definition.selector) || host, html: parsed.innerHTML, full: parsed.classList.contains('thb-cart-form--full') });
    }
    var provider = document.querySelector('#Cart-Drawer .seal-widget, #Cart .seal-widget');
    updates.forEach(function (update) {
      update.target.innerHTML = update.html;
      if (update.host.id === 'Cart') update.target.classList.toggle('thb-cart-form--full', update.full);
      var controller = update.host.cbmCartController || update.host.cbmCartDrawerController;
      if (controller) {
        controller.removeProductEvent();
        if (controller.notesToggle) controller.notesToggle();
        controller.termsCheckbox();
        controller.setNeedsSync(false);
        if (controller.cbmQuantityFeedback) controller.cbmQuantityFeedback.render();
      } else if (update.host.id === 'Cart' && typeof Cart !== 'undefined') {
        new Cart();
      } else if (update.host.id === 'Cart-Drawer' && typeof CartDrawer !== 'undefined') {
        new CartDrawer();
      }
    });
    if (document.cbmProtectionCheckout) document.cbmProtectionCheckout.render();
    placeSeelForVisibleCart(document, provider);
    placeProviderWidgets(document.getElementById('Cart-Drawer'));
    placeProviderWidgets(document.getElementById('Cart'));
    return updates.length > 0;
  }

  function finalizeCartMutation(operation, item, drawer, onError) {
    return Promise.resolve(operation).catch(function (error) {
      return Promise.resolve(typeof onError === 'function' ? onError(error) : null).then(function () { return null; });
    }).finally(function () {
      if (item && item.classList) item.classList.remove('thb-loading');
      if (drawer && typeof drawer.removeAttribute === 'function') drawer.removeAttribute('aria-busy');
    });
  }

  function requestWithTimeout(win, url, options, timeoutMs, readResponse) {
    if (!win || typeof win.fetch !== 'function') return Promise.reject(new Error('cart-fetch-unavailable'));
    var controller = typeof win.AbortController === 'function' ? new win.AbortController() : null;
    var requestOptions = Object.assign({}, options, controller ? { signal: controller.signal } : {});
    var request = Promise.resolve().then(function () { return win.fetch(url, requestOptions); })
      .then(function (response) { return readResponse ? readResponse(response) : response; });
    var timer;
    var timeout = new Promise(function (resolve, reject) {
      timer = win.setTimeout(function () {
        if (controller) controller.abort();
        reject(new Error('cart-request-timeout'));
      }, timeoutMs);
    });
    return Promise.race([request, timeout]).finally(function () {
      win.clearTimeout(timer);
    });
  }

  function requestJSON(win, url, options, timeoutMs) {
    return requestWithTimeout(win, url, options, timeoutMs, function (response) {
      if (!response.ok) throw new Error('cart-request-failed');
      return response.json().then(function (state) {
        if (!state || state.errors) throw new Error('cart-response-error');
        return state;
      });
    });
  }

  function toastTop(document) {
    var header = document && typeof document.querySelector === 'function'
      ? document.querySelector('#header')
      : null;
    var rect = header && typeof header.getBoundingClientRect === 'function'
      ? header.getBoundingClientRect()
      : null;
    var bottom = rect ? Number(rect.bottom) : 0;
    return Math.max(12, Math.round((Number.isFinite(bottom) ? Math.max(0, bottom) : 0) + 12));
  }

  function requestDiscount(win, codes) {
    var route = String(win.theme && win.theme.routes && win.theme.routes.cart_update_url || '/cart/update');
    var url = route.replace(/\.js$/, '') + '.js';
    return requestJSON(win, url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(buildDiscountPayload(codes, win.location && win.location.pathname, Boolean(win.document && win.document.getElementById('Cart'))))
    }, 8000);
  }

  function rebindNativeCart(document, Controller) {
    var drawer = document && document.getElementById('Cart-Drawer');
    if (!drawer || typeof Controller !== 'function') return false;
    var controller = Object.create(Controller.prototype);
    controller.container = drawer;
    controller.removeProductEvent();
    controller.notesToggle();
    controller.termsCheckbox();
    return true;
  }

  function setFormBusy(form, busy) {
    if (!form) return;
    if (form.classList) form.classList.toggle('is-loading', busy);
    ['[data-cbm-discount-input]', 'button[type="submit"]'].forEach(function (selector) {
      var control = form.querySelector(selector);
      if (control) control.disabled = busy;
    });
  }

  function showDiscountFeedback(form, message) {
    var feedback = form && form.querySelector('[data-cbm-discount-feedback]');
    if (!feedback) return;
    feedback.textContent = message || '';
    feedback.hidden = !message;
  }

  function applyDiscount(document, win, form, codes, submittedCode, Parser, Controller) {
    if (document.cbmDiscountPending) return Promise.resolve(false);
    var drawer = document.getElementById('Cart-Drawer');
    var previousCodes = manualCodes(drawer);
    var previousTotal = drawer && drawer.querySelector('[data-cbm-cart-total-amount]')?.textContent;
    var previousFee = drawer && drawer.querySelector('[data-cbm-seel-localized-price]')?.textContent;
    var restoring = false;
    document.cbmDiscountPending = true;
    // Discount-only changes do not trigger a Seel quote; preserve any actual provider wait.
    if (document.cbmProtectionCheckout) document.cbmProtectionCheckout.render();
    setFormBusy(form, true);
    showDiscountFeedback(form, '');
    return requestDiscount(win, codes).then(async function (state) {
      var drawerHTML = state.sections && state.sections['cart-drawer'];
      if (typeof drawerHTML !== 'string' || !new Parser().parseFromString(drawerHTML, 'text/html').querySelector('.cart-drawer')) throw new Error('discount-sections-missing');
      var invalid = submittedCode && !hasRenderedCode(state.sections && state.sections['cart-drawer'], submittedCode, Parser);
      if (invalid && previousCodes.length) {
        restoring = true;
        state = await requestDiscount(win, previousCodes);
      }
      if (!replaceSections(document, state && state.sections, Parser)) throw new Error('discount-sections-missing');
      if (document.cbmProtectionCheckout) {
        var sameAmounts = previousTotal === drawer.querySelector('[data-cbm-cart-total-amount]')?.textContent && previousFee === drawer.querySelector('[data-cbm-seel-localized-price]')?.textContent;
        document.cbmProtectionCheckout.confirm(state, sameAmounts);
      }
      var currentForm = document.querySelector('[data-cbm-discount-form]') || form;
      var restoreFailed = restoring && !previousCodes.every(function (code) {
        return hasRenderedCode(state.sections['cart-drawer'], code, Parser);
      });
      showDiscountFeedback(currentForm, restoreFailed ? win.theme.strings.discountRestoreError : invalid ? currentForm.dataset.cbmDiscountInvalid : '');
      try {
        rebindNativeCart(document, Controller);
        placeProviderWidgets(document.getElementById('Cart-Drawer'));
      } catch (optionalUiError) {
        // Shopify already accepted the discount; optional UI rebinds must not report a false failure.
      }
      return !restoreFailed;
    }).catch(async function () {
      if (document.cbmProtectionCheckout) document.cbmProtectionCheckout.fail();
      if (restoring || previousCodes.length) {
        var host = document.getElementById('Cart') || document.getElementById('Cart-Drawer');
        var controller = host && (host.cbmCartController || host.cbmCartDrawerController);
        if (controller) {
          controller.setNeedsSync(true);
          try { await controller.refresh(); } catch (readError) { controller.setNeedsSync(true); }
        }
      }
      var currentForm = document.querySelector('[data-cbm-discount-form]') || form;
      showDiscountFeedback(currentForm, restoring ? win.theme.strings.discountRestoreError : currentForm.dataset.cbmDiscountError);
      return false;
    }).finally(function () {
      setFormBusy(document.querySelector('[data-cbm-discount-form]') || form, false);
      document.cbmDiscountPending = false;
      if (document.cbmProtectionCheckout) document.cbmProtectionCheckout.render();
    });
  }

  function openCart(document, win) {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;
    document.body.classList.add('open-cc');
    drawer.classList.add('active');
    if (drawer.focus) drawer.focus();
    if (document.dispatchEvent && win.CustomEvent) {
      document.dispatchEvent(new win.CustomEvent('cart-drawer:open'));
    }
  }

  function showAddedToast(document, win) {
    var toast = document.querySelector('.cbm-cart-added-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cbm-cart-added-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      var message = document.createElement('span');
      message.className = 'cbm-cart-added-toast__message';
      message.textContent = win.theme.strings.addedToCart;
      var action = document.createElement('button');
      action.className = 'cbm-cart-added-toast__action';
      action.type = 'button';
      action.textContent = win.theme.strings.viewCart;
      action.addEventListener('click', function (event) {
        event.preventDefault();
        openCart(document, win);
        toast.classList.remove('is-visible');
      });
      toast.appendChild(message);
      toast.appendChild(action);
      document.body.appendChild(toast);
    }
    if (toast.style && typeof toast.style.setProperty === 'function') {
      toast.style.setProperty('--cbm-toast-top', toastTop(document) + 'px');
    }
    if (toast.cbmTimer) win.clearTimeout(toast.cbmTimer);
    toast.classList.add('is-visible');
    toast.cbmTimer = win.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3500);
    return toast;
  }

  function syncShippingStatusFromHoppy(drawer) {
    if (!drawer || typeof drawer.querySelector !== 'function' || typeof drawer.querySelectorAll !== 'function') return null;
    var nativeProgress = drawer.querySelector('[data-cbm-native-shipping]');
    if (nativeProgress) {
      var nativeStatus = nativeProgress.dataset.reached === 'true' ? 'free' : 'calculated';
      Array.prototype.forEach.call(drawer.querySelectorAll('[data-cbm-shipping-status]'), function (element) {
        var nativeHidden = element.getAttribute('data-cbm-shipping-status') !== nativeStatus;
        if (element.hidden !== nativeHidden) element.hidden = nativeHidden;
      });
      return nativeStatus;
    }
    var progress = drawer.querySelector('#shipping-container-cart_drawer .basic-bar-fill');
    var width = progress && progress.style ? parseFloat(progress.style.width) : NaN;
    if (!Number.isFinite(width)) return null;
    var status = width >= 99.5 ? 'free' : 'calculated';
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-cbm-shipping-status]'), function (element) {
      var hidden = element.getAttribute('data-cbm-shipping-status') !== status;
      if (element.hidden !== hidden) element.hidden = hidden;
    });
    return status;
  }

  function placeSeelForVisibleCart(document, retainedWidget) {
    var drawer = document.getElementById('Cart-Drawer');
    var pageCart = document.getElementById('Cart');
    var widget = retainedWidget || document.querySelector('#Cart-Drawer .seal-widget, #Cart .seal-widget');
    var inDrawer = !pageCart || (drawer && drawer.classList.contains('active'));
    var slot = inDrawer ? drawer && drawer.querySelector('[data-cbm-seel-slot]') : pageCart.querySelector('.thb-cart-collaterals');
    if (!widget || !slot) return;
    if (widget.parentElement !== slot) {
      var checkout = !inDrawer && slot.querySelector('.proceed-to-checkout');
      slot.insertBefore(widget, checkout || null);
    }
  }

  function reconcileProviderCart(document) {
    var pageCart = document.getElementById('Cart');
    var drawer = document.getElementById('Cart-Drawer');
    var pageTotal = pageCart && pageCart.querySelector('.cart-total .amount');
    var drawerTotal = drawer && drawer.querySelector('[data-cbm-cart-total-amount]');
    if (!pageTotal || !drawerTotal || !pageCart.cbmCartController) return;
    var left = pageTotal.textContent.replace(/\s/g, '');
    var right = drawerTotal.textContent.replace(/\s/g, '');
    if (left === right) { pageCart.cbmProviderMismatch = ''; return; }
    var signature = left + '|' + right;
    if (pageCart.cbmProviderSync || pageCart.cbmProviderMismatch === signature) return;
    pageCart.cbmProviderMismatch = signature;
    pageCart.cbmCartController.setNeedsSync(true);
    if (drawer.cbmCartDrawerController) drawer.cbmCartDrawerController.setNeedsSync(true);
    pageCart.cbmProviderSync = pageCart.cbmCartController.refresh();
    pageCart.cbmProviderSync.finally(function () { pageCart.cbmProviderSync = null; });
  }

  function placeProviderWidgets(drawer) {
    if (!drawer) return 0;
    if (drawer.ownerDocument) placeSeelForVisibleCart(drawer.ownerDocument);
    var moves = 0;
    [
      ['#shipping-container-cart_drawer', '[data-cbm-hoppy-slot]', 'data-cbm-cart-progress'],
      ['.seal-widget', '[data-cbm-seel-slot]', 'data-cbm-provider-managed']
    ].forEach(function (definition) {
      var widget = drawer.querySelector(definition[0]);
      var slot = drawer.querySelector(definition[1]);
      if (!widget || !slot) return;
      widget.setAttribute(definition[2], '');
      if (widget.parentElement !== slot) {
        slot.appendChild(widget);
        moves += 1;
      }
    });

    var localizedSeelPrice = drawer.querySelector('[data-cbm-seel-localized-price]');
    var seelPrice = drawer.querySelector('[data-seel-wfp-price]');
    var providerInput = drawer.querySelector('.seal-widget [data-seel-wfp-input]');
    if (localizedSeelPrice && seelPrice && !seelPrice.classList.contains('loading-animation') && !(providerInput && providerInput.disabled)) {
      var localizedText = String(localizedSeelPrice.textContent || '').trim();
      var currentText = String(seelPrice.textContent || '').trim();
      var labels = localizedSeelPrice.dataset || {};
      var prefix = labels.cbmSeelPrefix;
      if (typeof prefix !== 'string') {
        var amountStart = currentText.search(/[$€£¥0-9]/);
        prefix = amountStart > 0 ? currentText.slice(0, amountStart).trim() : '';
      }
      var nextText = localizedText
        ? (prefix ? prefix + ' ' : '') + localizedText
        : labels.cbmSeelPricePending;
      if (nextText && currentText !== nextText) seelPrice.textContent = nextText;
    }
    syncShippingStatusFromHoppy(drawer);
    return moves;
  }

  function scrollRecommendations(button) {
    var container = button && button.closest('[data-cbm-recommendations]');
    var track = container && container.querySelector('.complementary-products--inner');
    if (!track || typeof track.scrollTo !== 'function') return false;
    var direction = button.matches('[data-cbm-recommendation-prev]') ? -1 : 1;
    track.scrollTo({ left: nextScrollLeft(track, direction), behavior: 'smooth' });
    return true;
  }

  function updateRecommendationControls(container) {
    var track = container && container.querySelector('.complementary-products--inner');
    var previous = container && container.querySelector('[data-cbm-recommendation-prev]');
    var next = container && container.querySelector('[data-cbm-recommendation-next]');
    var controls = container && container.querySelector('.cbm-cart-recommendation-controls');
    if (!track || !previous || !next || !controls) return false;
    var maximum = Math.max(0, Number(track.scrollWidth) - Number(track.clientWidth));
    var hasOverflow = maximum > 1;
    controls.hidden = !hasOverflow;
    previous.disabled = !hasOverflow || Number(track.scrollLeft) <= 1;
    next.disabled = !hasOverflow || Number(track.scrollLeft) >= maximum - 1;
    return true;
  }

  function updateAllRecommendationControls(drawer) {
    if (!drawer || typeof drawer.querySelectorAll !== 'function') return;
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-cbm-recommendations]'), updateRecommendationControls);
  }

  function manualCodes(drawer) {
    if (!drawer) return [];
    return Array.prototype.map.call(drawer.querySelectorAll('[data-cbm-discount-code]'), function (chip) {
      return chip.getAttribute('data-cbm-discount-code');
    });
  }

  function nativeCartController() {
    return typeof CartDrawer === 'function' ? CartDrawer : null;
  }

  function boot(document, win) {
    if (booted) return;
    var start = function () {
      if (booted) return;
      var drawer = document.getElementById('Cart-Drawer');
      var pageCart = document.getElementById('Cart');
      if (!drawer && !pageCart) return;
      booted = true;
      document.cbmProtectionCheckout = protectionCheckoutGuard(document, win);
      placeProviderWidgets(drawer);
      placeProviderWidgets(pageCart);
      updateAllRecommendationControls(drawer);

      document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!form || !form.matches || !form.matches('[data-cbm-discount-form]')) return;
        event.preventDefault();
        var input = form.querySelector('[data-cbm-discount-input]');
        var code = input && input.value;
        if (!String(code || '').trim()) return;
        applyDiscount(document, win, form, discountCodesForSubmission(manualCodes(drawer), code), code, win.DOMParser, nativeCartController());
      });

      document.addEventListener('click', function (event) {
        var target = event.target && event.target.closest ? event.target : null;
        if (!target) return;
        var arrow = target.closest('[data-cbm-recommendation-prev], [data-cbm-recommendation-next]');
        if (arrow) {
          event.preventDefault();
          scrollRecommendations(arrow);
          return;
        }
        var remove = target.closest('[data-cbm-discount-remove]');
        if (!remove) return;
        event.preventDefault();
        var code = remove.getAttribute('data-cbm-discount-remove');
        var form = remove.closest('[data-cbm-discount-form]');
        var remaining = manualCodes(drawer).filter(function (value) {
          return String(value).toLowerCase() !== String(code).toLowerCase();
        });
        applyDiscount(document, win, form, remaining, '', win.DOMParser, nativeCartController());
      });

      document.addEventListener('cart:item-added', function () {
        showAddedToast(document, win);
      });

      document.addEventListener('scroll', function (event) {
        var track = event.target;
        if (!track || !track.matches || !track.matches('.complementary-products--inner')) return;
        updateRecommendationControls(track.closest('[data-cbm-recommendations]'));
      }, true);

      win.addEventListener('resize', function () {
        updateAllRecommendationControls(document.getElementById('Cart-Drawer'));
      });

      if (typeof win.MutationObserver === 'function') {
        var observer = new win.MutationObserver(function () {
          if (providerUpdateQueued) return;
          providerUpdateQueued = true;
          (win.requestAnimationFrame || win.setTimeout)(function () {
            providerUpdateQueued = false;
            var currentDrawer = document.getElementById('Cart-Drawer');
            placeProviderWidgets(currentDrawer);
            placeProviderWidgets(document.getElementById('Cart'));
            updateAllRecommendationControls(currentDrawer);
            reconcileProviderCart(document);
            document.cbmProtectionCheckout.check();
          });
        });
        [drawer, pageCart].forEach(function (container) {
          if (container) observer.observe(container, { attributes: true, attributeFilter: ['style', 'class', 'disabled'], characterData: true, childList: true, subtree: true });
        });
      }
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  }

  return {
    quantityChangeHandler: quantityChangeHandler,
    normalizeCodes: normalizeCodes,
    buildDiscountPayload: buildDiscountPayload,
    discountCodesForSubmission: discountCodesForSubmission,
    nextScrollLeft: nextScrollLeft,
    hasRenderedCode: hasRenderedCode,
    replaceSections: replaceSections,
    finalizeCartMutation: finalizeCartMutation,
    requestWithTimeout: requestWithTimeout,
    requestJSON: requestJSON,
    toastTop: toastTop,
    requestDiscount: requestDiscount,
    rebindNativeCart: rebindNativeCart,
    applyDiscount: applyDiscount,
    showAddedToast: showAddedToast,
    syncShippingStatusFromHoppy: syncShippingStatusFromHoppy,
    placeProviderWidgets: placeProviderWidgets,
    scrollRecommendations: scrollRecommendations,
    updateRecommendationControls: updateRecommendationControls,
    boot: boot
  };
});


